import script from "./BaseGridRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseGridRow.vue?vue&type=script&lang=ts&setup=true"

import "./BaseGridRow.vue?vue&type=style&index=0&id=2c937835&lang=scss"

const __exports__ = script;

export default __exports__